export const parseData = data => {
  return data.trim().split('\n\n')
    .map((sent) => {
      const splitSent = sent.split('\n');
      return splitSent.map((wordLine) => {
        const wordInfo = wordLine.trim().split('\t');
        return { word: wordInfo[0], pos: wordInfo[1], tag: wordInfo[2]}
      });
    });
};